import { render, staticRenderFns } from "./export-proof-edit-columns.vue?vue&type=template&id=3e85c026"
import script from "./export-proof-edit-columns.vue?vue&type=script&lang=js"
export * from "./export-proof-edit-columns.vue?vue&type=script&lang=js"
import style0 from "./export-proof-edit-columns.vue?vue&type=style&index=0&id=3e85c026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports